import React from 'react'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import './styles.css'

import { Autoplay, Pagination } from 'swiper/modules'

import { Swiper, SwiperSlide } from 'swiper/react'

interface ImagesProps {
  perguntaArquivos?: {
    id: string
    arquivoLink: string
    nomeOriginal: string
    tipo: string
  }[]
}

export default function CarouselQuizImage({ perguntaArquivos }: ImagesProps) {
  return (
    <div className=''>
      <Swiper
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className='prodruct-visualization-carousel'
      >
        {perguntaArquivos?.map((item, index) => (
          <>
            <SwiperSlide
              key={index}
              className='flex items-center justify-center rounded-xl bg-gradient-to-tr from-esforce-pink-200 from-10% via-transparent via-50% to-esforce-pink-200 to-100% p-1.5'
            >
              {item.tipo === 'image' && (
                <img
                  src={item.arquivoLink}
                  alt={item.nomeOriginal}
                  className='h-80 w-full cursor-pointer rounded-xl'
                />
              )}
              {item.tipo === 'video' && (
                <video
                  key={index}
                  controls
                  className='w-full cursor-pointer rounded-xl md:h-80'
                >
                  <source src={item.arquivoLink} type='video/mp4' />
                  Your browser does not support the video tag.
                </video>
              )}
            </SwiperSlide>
          </>
        ))}
      </Swiper>
    </div>
  )
}
